/**
 * Manipula los datos de la llamada, en este caso, detectamos el tipo de landing y en función de eso se carga uno u otro script
 */

import {
  isButtons,
  isModal,
  isPubliLanding,
  isVoid,
  notDRP,
  coinscrap,
  isVida,
  isCallme,
  hubtype,
  isCotizador,
  isTestAb,
  general

} from '../helpers/actionsDependingURL'

const DICTIONARY_CASES = Object.freeze({
  MODAL: 'Modal',
  BUTTONS: 'Buttons',
  VOID: 'void',
  FORM: 'form',
  LANDING: 'landing',
  NOT_DRP: 'No-ringpool',
  COINSCRAP: 'coinscrap',
  VIDA: 'vida',
  CALLME: 'solo-callme',
  HUBTYPE: 'hubtype',
  COTIZADOR: 'cotizador',
  ISTESTAB:'isTestAb',
  GENERAL: 'general'


})

export function handleResponse(data) {
  if (data === null) return;
  console.log(JSON.parse(data.value));

  const { action } = JSON.parse(data.value);

  window.DFI_client.action = action;
  window.tipoUrlTag = action;

  if (action === DICTIONARY_CASES.MODAL) return isModal();
  if (action === DICTIONARY_CASES.BUTTONS) return isButtons();
  if (action === DICTIONARY_CASES.GENERAL) return general();
  if (action === DICTIONARY_CASES.ISTESTAB) return isTestAb();
  if (action === DICTIONARY_CASES.VOID || action === DICTIONARY_CASES.FORM) {
    return isVoid();
  }
  if (action === DICTIONARY_CASES.LANDING) return isPubliLanding();
  if (action === DICTIONARY_CASES.NOT_DRP) return notDRP();
  if (action === DICTIONARY_CASES.COINSCRAP) return coinscrap();
  if (action === DICTIONARY_CASES.HUBTYPE) return hubtype();
  if (action === DICTIONARY_CASES.COTIZADOR) return isCotizador();
  if (action === DICTIONARY_CASES.VIDA) return isVida();
  if (action === DICTIONARY_CASES.CALLME) return isCallme();
  console.warn('Acción no reconocida, asignando comportamiento de modal.');
  return isModal();
}
